export const optionTitle_messageHeight = "Hnd";
export const optionTitle_textSizeSpacing = "Ind";
export default {optionTitle_messageHeight,optionTitle_textSizeSpacing};